import { ApiService, apiServiceInstance } from './ApiService';
import { EventService, eventServiceInstance } from './EventService';
import { personalDataServiceInstance } from './PersonalDataService';

export class CollectService {
  private apiServiceInstance: ApiService;

  private eventServiceInstance: EventService;

  public constructor () {
    this.apiServiceInstance = apiServiceInstance;
    this.eventServiceInstance = eventServiceInstance;
  }

  public async sendConsents (experienceId: string, consents: Record<string, boolean>, siteKey: string, shopperId: string, token = ''): Promise<void> {
    await Promise.all([
      ...Object.entries(consents)
        .map(([key, value]) => {
          if (value) {
            return this.eventServiceInstance.sendOptinAcceptedEventToShopperEvent(siteKey, shopperId, experienceId, key);
          }
          return this.eventServiceInstance.sendOptinRefusedEventToShopperEvent(siteKey, shopperId, experienceId, key);
        }),
      personalDataServiceInstance.saveOptins(siteKey, shopperId, consents, token),
    ]);
  }

  public async sendPersonalData (experienceId: string, personalData: Record<string, string>, siteKey: string, shopperId: string): Promise<void> {
    if (personalData.email !== undefined) {
      await this.eventServiceInstance.sendEmailEventToShopperEvent(siteKey, shopperId, experienceId, personalData.email);
    }
  }
}

export const collectServiceInstance = new CollectService();
